import { useState } from 'react';
import classNames from 'classnames';
import { Button } from 'primereact/button';
import NewCard from '@shared/images/svg/cardIcons/NewCard.svg';
import SBP from '@shared/images/svg/cardIcons/SBP.svg';

import styles from './styles.module.scss';

type Props = {
    closeModal: (cardType: 'CARD' | 'SBP') => void;
};

export const InfoModal = ({ closeModal }: Props) => {
    const [cardType, setCardType] = useState<'CARD' | 'SBP'>('CARD');

    return (
        <div className={classNames(styles.infoModalWrapper)}>
            <h2>Добавление способа оплаты</h2>
            <div>
                <p>При следующей оплате вводить данные не потребуется - списание произойдет автоматически.</p>
                <p>
                    Сохраняя способ оплаты, Вы соглашаетесь на его автоматическую привязку к вашей учетной записи для
                    списания средств при продлении услуг на нашей платформе.
                </p>
                <p>
                    Все данные хранятся в зашифрованном виде. Вы можете в любой момент отвязать способ оплаты и
                    отключить автосписание в личном кабинете.
                </p>
            </div>
            <div className={styles.cardTypeBlock}>
                <p>Выберете способ оплаты:</p>
                <div>
                    <div
                        className={classNames(styles.cardType, cardType === 'CARD' && styles.isActive)}
                        onClick={() => setCardType('CARD')}
                    >
                        <img src={NewCard} alt="payment-card-logo" />
                        <span>Банковская карта</span>
                    </div>
                    <div
                        className={classNames(styles.cardType, cardType === 'SBP' && styles.isActive)}
                        onClick={() => setCardType('SBP')}
                    >
                        <img src={SBP} alt="payment-card-logo" />
                        <span>Счет СБП</span>
                    </div>
                </div>
            </div>
            <Button label={'Продолжить'} onClick={() => closeModal(cardType)} />
        </div>
    );
};
